// src/actions/jobActions.js
import { createAsyncThunk } from '@reduxjs/toolkit';
import { http } from '../api/http'; // central axios (baseURL + token)

// Create a new job with form-data, including the manifest file
export const createJob = createAsyncThunk(
  'jobs/createJob',
  async ({ formData, componentId }, { rejectWithValue }) => {
    try {
      console.log('Submitting formData to the server with componentId:', componentId);

      // Optional: debug formData
      // for (const [k, v] of formData.entries()) console.log(k, v);

      const { data } = await http.post(
        `/jobs/${componentId}/jobs`, // componentId in the route
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      console.log('Server response:', data);
      return data;
    } catch (error) {
      console.log('Error occurred:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const deleteJob = createAsyncThunk(
  'jobs/deleteJob',
  async (jobId, { rejectWithValue }) => {
    try {
      await http.delete(`/jobs/${jobId}`); // matches deleteJob controller (req.params.id)
      return jobId;
    } catch (error) {
      console.log('Error occurred while deleting job:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);